import React, { Component } from "react";
import httpService from "./AxiosInterceptors";
import { authService } from "./auth";
import { capitalizeFirstLetter } from "./project/component/Studio/StudioContentCommonFunction";
import { withRouter } from "react-router-dom";

httpService.setupInterceptors()

class ActivitySuggestionModalPopUp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage()
        }
    }

    redirectToSuggestionpage = (data) => {
        this.props.history.push({
            pathname: data === "EXPLORE" || data === "NATURE_CONTENT_AND_MONETISATION" ? "/explore" : data === "EXPLORE_AND_TRENDING" ? "/explore-trending" : data === "NETWORK" ? "/network" : data === "COMMUNITY" ? "/communities" : "/project"
        })
    }

    componentWillUnmount() {
        window.$("#activitySuggestionModal").modal("hide");
    }

    componentDidMount() {
        window.$("#activitySuggestionModal").modal("show");
    }

    render() {
        const { activitySugestionData } = this.props;

        return (
            <div id="activitySuggestionModal" className="modal fade dgpopup" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body" style={{ maxWidth: "500px", width: "100%", margin: "auto" }}>
                            <div className="sProjectListPop datePart">
                                <button type="button" className="close topCrossModal" aria-label="Close" onClick={() => this.props.onCloseActivitySuggestionModal()}>
                                    <i className="iCross" />
                                </button>
                                <h2>WeNAT: Activity Suggestion</h2>
                                <div className="row">
                                    {activitySugestionData?.suggestions?.map((data) => {
                                        return (
                                            <>
                                                <div className="col-md-6 col-xs-12">
                                                    <label className="suggestion-control-label" onClick={() => this.redirectToSuggestionpage(data)}>{capitalizeFirstLetter(data?.toLowerCase())?.replace(/\_+/gi, "-")}</label>
                                                </div>
                                            </>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(ActivitySuggestionModalPopUp);